/* eslint-disable indent */
import {
  DownOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MessageOutlined,
  UploadOutlined,
  UserOutlined
} from '@ant-design/icons';
import { ACCOUNT, MESSAGES, ADD_PRODUCT } from 'constants/routes';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { signOut } from 'redux/actions/authActions';
import { useTranslation } from 'react-i18next';
import { useList } from 'react-firebase-hooks/database';
import { ref } from 'firebase/database';
import firebase from 'firebase/firebase';
import defaultAvatar from '../../../images/defaultAvatar.png';
import Badge from '../../../components/common/Badge';

const UserNav = () => {
  const { t } = useTranslation();
  const { profile, isAuthenticating } = useSelector((state) => ({
    profile: state.profile,
    isAuthenticating: state.app.isAuthenticating
  }));
  const store = useSelector((state) => ({
    user: state.auth
  }));
  const userNav = useRef(null);
  const [chats, isLoadingChats] = useList(
    ref(firebase.rdb, `users/${store.user.id}/chats`)
  );
  const dispatch = useDispatch();

  const toggleDropdown = (e) => {
    const closest = e.target.closest('div.user-nav');

    try {
      if (
        !closest &&
        userNav.current &&
        userNav.current.classList.contains('user-sub-open')
      ) {
        userNav.current.classList.remove('user-sub-open');
      }
    } catch (err) {
      console.error(err);
    }
  };

  function displayBadge() {
    let counter = 0;
    if (!isLoadingChats && chats?.length !== 0) {
      chats.map((chat) => {
        if (chat.val().unread > 0) counter += 1;
        return counter;
      });
    }
    if (counter > 0) return <Badge count={counter} />;
    return '';
  }

  function displayNumber() {
    let counter = 0;
    if (!isLoadingChats && chats?.length !== 0) {
      chats.map((chat) => {
        if (chat.val().unread > 0) counter += 1;
        return counter;
      });
    }
    if (counter > 0) return ` (${counter})`;
    return '';
  }

  useEffect(() => {
    document.addEventListener('click', toggleDropdown);

    return () => document.removeEventListener('click', toggleDropdown);
  }, []);

  const onClickNav = () => {
    userNav.current.classList.toggle('user-sub-open');
  };

  return isAuthenticating ? (
    <div className="user-nav">
      <span>{t('menuSigningOut')}</span>
      &nbsp;
      <LoadingOutlined />
    </div>
  ) : (
    <div
      className="user-nav"
      onClick={onClickNav}
      onKeyDown={() => {}}
      ref={userNav}
      role="button"
      tabIndex={0}
    >
      <h5 className="text-overflow-ellipsis">
        {profile.fullname && profile.fullname.split(' ')[0]}
      </h5>
      <div className="user-nav-img-wrapper">
        <img
          alt=""
          className="user-nav-img"
          src={profile.avatar || defaultAvatar}
        />
      </div>
      {displayBadge()}
      <DownOutlined style={{ fontSize: '1.2rem', marginLeft: '1rem' }} />
      <div className="user-nav-sub">
        {profile.role !== 'ADMIN' && (
          <>
            <Link to={ACCOUNT} className="user-nav-sub-link">
              {t('menuViewAccount')}
              <UserOutlined />
            </Link>
            <Link to={ADD_PRODUCT} className="user-nav-sub-link">
              {t('menuNewProduct')}
              <UploadOutlined />
            </Link>
          </>
        )}
        <Link to={MESSAGES} className="user-nav-sub-link">
          {t('menuMessages')}
          {displayNumber()}
          <MessageOutlined />
        </Link>
        <h6
          className="user-nav-sub-link margin-0 d-flex"
          onClick={() => dispatch(signOut())}
          role="presentation"
        >
          {t('menuLogout')}
          <LogoutOutlined />
        </h6>
      </div>
    </div>
  );
};

UserNav.propType = {
  profile: PropTypes.object.isRequired
};

export default withRouter(UserNav);
